// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3eirl","buttons":"RemoveExpirationActionButtons_buttons__UoPjq"};